import { apis, useRequest } from "../utils";
import { registerMF } from "@gw/gw-utils";
import type { UseRequestResult } from "@gw/gw-request/types";

/** 物料容器属性 */
interface ProducerItem {
  id: string;
  name: string;
  alias: string;
  entry: string;
  activePath: string;
  createdAt?: string;
  updatedAt?: string;
}

interface RegisterMFParams {
  /** 主站地址,不传的话则按需配置代理 */
  origin?: string;
  /** 当前项目名称 */
  projectName: string;
}

/**
 * 获取远端容器
 * @returns
 */
const useProducers = () => {
  const res = useRequest<void, IResDataList<ProducerItem>>(apis.producers.list);

  return res;
};

/**
 * 注册远端容器
 * @param params
 */
const useRegisterMF = (
  params: RegisterMFParams
): UseRequestResult<{ regist?: boolean }, ProducerItem[]> => {
  const { origin = "", projectName } = params;

  const [{ data, ...rest }, fetchProducers, op] = useProducers();

  const register = async ({ regist = true }) => {
    const res = await fetchProducers();
    const producers = res.dataList.filter((r) => r.alias !== projectName);
    if (regist) registerMF({ producers, origin });
    return producers;
  };

  return [
    { data: data?.dataList.filter((r) => r.alias !== projectName), ...rest },
    register,
    op,
  ];
};

export default useRegisterMF;
